import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import styled from "styled-components"
import uniqid from "uniqid"
import PersonCardShape from "../../state/shapes/PersonCardShape"

const PersonName = styled.span`
  font-weight: bold;
  float: left;
`
const PersonDetails = styled.span`
  font-size: 10px;
`

const IncludeDirectReportsLabel = styled.span`
  padding-right: 0.5em;
  font-size: 12px;
`

const PersonCard = ({
  item,
  highlightedItem,
  t,
  showIncludeDirectCheckbox,
  includeDirectReportsChangeHandler,
}) => {
  const Status = styled.span.attrs({
    className: (styleStatus) => {
      if (styleStatus.statusId === 1) return "label label-success"
      if (styleStatus.statusId === 5) return "label label-danger"
      return "label label-warning"
    },
  })`
    font-size: 10px;
    float: right;
  `

  const Div = styled.div`
    background-color: ${highlightedItem ? "rgba(0,0,0,0.12)" : "rgba(0,0,0,0)"};
    cursor: pointer;
    padding: 0.5em;
  `

  const checkboxId = `chk_${uniqid()}_IncludeDirectReports`

  const onDirectChanged = (e) => {
    includeDirectReportsChangeHandler(item.employeeId, e.target.checked)
  }

  return (
    <Div>
      <div>
        <PersonName>{item.name}</PersonName>
        <Status statusId={item.statusId}>{t(item.statusTranslationIdentifier)}</Status>
      </div>
      <br />
      <PersonDetails>{t(item.jobTitle)}</PersonDetails>
      <br />
      <PersonDetails>{item.location}</PersonDetails>
      <Fragment>
        {showIncludeDirectCheckbox ? (
          <div>
            <IncludeDirectReportsLabel>
              {t("CustomReport.Common.IncludeDirectReports")}
            </IncludeDirectReportsLabel>
            <input
              id={checkboxId}
              type="checkbox"
              checked={item.includeDirectReports}
              onChange={onDirectChanged}
            />
            <label htmlFor={checkboxId}>&nbsp;</label>
          </div>
        ) : null}
      </Fragment>
    </Div>
  )
}

PersonCard.propTypes = {
  item: PropTypes.shape(PersonCardShape).isRequired,
  highlightedItem: PropTypes.bool.isRequired,
  showIncludeDirectCheckbox: PropTypes.bool,
  includeDirectReportsChangeHandler: PropTypes.func,
  t: PropTypes.func.isRequired,
}

PersonCard.defaultProps = {
  showIncludeDirectCheckbox: null,
  includeDirectReportsChangeHandler: null,
}
export default translate()(PersonCard)



// WEBPACK FOOTER //
// ./src/components/widgets/PersonCard.jsx